import { useMemo, useState } from 'react';
import { listingItemtype } from 'types/ledger';

const useSearchEndorsement = (endorsements: listingItemtype[], selectedEndorsementList: string[]) => {
  const [search, setSearch] = useState('');

  const formated = useMemo(() => endorsements
    .filter(({ code }) => !selectedEndorsementList.some(endorsement => endorsement === code))
    .map((e) => (
      { ...e, description: `${e.code} - ${e.description}` }
    )), [endorsements, selectedEndorsementList]);

  const filtered = useMemo(() => (search.trim() === '' ? formated : (
    formated.filter((e) => e.description.toLowerCase().includes(search.toLowerCase()))
  )), [formated, search]);

  const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  return {
    search,
    endorsements: filtered,
    handleOnChange,
  };
};

export default useSearchEndorsement;
